import TripCollection from "@website/icons/components/trip-collection";
import { Accordion } from "@website/ui/accordion";
import Link from "next/link";
import { FC } from "react";
import { CMSLinkGroup, InboundLinksType } from "./inbound-links.types";

const InboundLinkItem = ({ links }: { links: CMSLinkGroup["links"] }) => (
  <div className="text-on-surface-high-emphasis flex w-full flex-col gap-3">
    {links.map((item) => (
      <Link
        className="underline-offset-8 hover:underline"
        href={item.linkValue}
        key={item.linkTitle}
        prefetch={false}
      >
        {item.linkTitle}
      </Link>
    ))}
  </div>
);

const masonryList = (list: Array<CMSLinkGroup>) => {
  const result: Array<Array<CMSLinkGroup>> = [[], [], []];
  for (const [index, element] of list.entries()) {
    const columnIndex = index % 3;
    result[columnIndex]?.push(element);
  }
  return result;
};

const InboundLinks: FC<InboundLinksType> = ({ title, linksData }) => {
  // Filter out groups with no title or empty links
  const validLinks = linksData.filter(
    (group) => group.LinksTitle && group.links && group.links.length > 0
  );

  if (validLinks.length === 0) {
    return null;
  }

  return (
    <section className="w-full py-8">
      <header className="mb-4 flex h-8 flex-row items-center gap-2">
        <TripCollection className="fill-on-surface-medium-emphasis text-xl" />
        <h2 className="text-on-surface-high-emphasis lg:text-headline-6 text-base">
          {title}
        </h2>
      </header>

      <div className="grid items-start gap-4 xl:grid-cols-3">
        {masonryList(validLinks)?.map((column, index) => (
          <div className="grid gap-4" key={`InboundLinks-${index++}`}>
            {column.map((linkGroup) => (
              <Accordion
                content={
                  linkGroup.links.length > 0 ? (
                    <InboundLinkItem links={linkGroup.links} />
                  ) : (
                    ""
                  )
                }
                initialExpanded
                key={linkGroup.LinksTitle}
                scroll="long"
                title={linkGroup.LinksTitle || ""}
              />
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};
export default InboundLinks;
